module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_XV"
    }
  }), _c('h1', {
    staticClass: "pre_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_XV"
    }
  }, [_c('span')]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXV"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ANF")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("The Ante-Nicene Fathers. 10 vols. Edited by Alexander Roberts and James Donaldson. Buffalo, NY: Christian Literature, 1885–1896. Available online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.ccel.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ccel.org")]), _vm._v(".")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ACCS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Ancient Christian Commentary on Scripture. 29 vols. Edited by Thomas C. Oden. Downers Grove, IL: InterVarsity Press, 1998–2009.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BoC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("The Book of Concord: The Confessions of the Evangelical Lutheran Church")]), _vm._v(". Edited by Robert Kolb and Timothy J. Wengert. Translated by Charles Arand et al. Minneapolis: Fortress, 2000.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BNP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Brill’s New Pauly: Encyclopedia of the Ancient World")]), _vm._v(". Edited by Hubert Cancik and Helmuth Schneider. 20 vols. Leiden: Brill, 2002–2011.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BRN")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Bibliotheca Reformatoria Neederlandica. 10 vols. Edited by S. Cramer and F. Pijper. The Hague: Martinus Nijhoff, 1903–1914. Digital copy online at babel.hathitrust.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BSLK")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Die Bekenntnisschriften der evangelisch-lutherischen Kirche")]), _vm._v(". 12th ed. Göttingen: Vandenhoeck & Ruprecht, 1998.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CHB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Cambridge History of the Bible. ")]), _vm._v("3 vols. Cambridge: Cambridge University Press, 1963–1970.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CNTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Calvin’s New Testament Commentaries")]), _vm._v(". 12 vols. Edited by D. W. Torrance and T. F. Torrance. Grand Rapids: Eerdmans, 1959–1972.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CO")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Ioannis Calvini Opera quae supersunt omnia")]), _vm._v(". 59 vols. Corpus Reformatorum 29–88. Edited by G. Baum, E. Cunitz and E. Reuss. Brunswick and Berlin: C. A. Schwetschke, 1863–1900. Digital copy online at archive-ouverte.unige.ch/Calvin.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Creeds")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Philip Schaff. "), _c('i', [_vm._v("The Creeds of Christendom: With a Critical History and Notes")]), _vm._v(". 3 vols. New York: Harper & Row, 1877. Reprint, Grand Rapids: Baker Books, 1977.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CRR")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Classics of the Radical Reformation. 12 vols. Waterloo, ON, and Scottdale, PA: Herald Press, 1973–2010.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CTS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Calvin Translation Society edition of Calvin’s commentaries. 46 vols. Edinburgh, 1843–1855. Several reprints, but variously bound; volume numbers (when cited) are relative to specific commentaries and not to the entire set.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CWE")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Collected Works of Erasmus")]), _vm._v(". 86 vols. planned. Toronto: University of Toronto Press, 1969–.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("DMBI")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Dictionary of Major Biblical Interpreters.")]), _vm._v(" Edited by Donald K. McKim. Downers Grove, IL: IVP Academic, 2007.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXVI"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XVI"
    }
  }, [_c('i', [_vm._v("DNB")])])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Dictionary of National Biography")]), _vm._v(". Edited by Leslie Stephen and Sidney Lee. 63 vols. London: Smith, Elder, 1885–1900. Digital copy online at en.wikisource.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("E"), _c('sup', [_vm._v("2")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Dr. Martin Luther’s sämmtliche Werke")]), _vm._v(". 2nd ed. 26 vols. Frankfurt and Erlangen: Heyder & Zimmer, 1862–1885. Digital copies online at babel.hathitrust.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("EEBO")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Early English Books Online. Subscription database, eebo.chadwyck.com.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("FC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Fathers of the Church: A New Translation. Washington, DC: Catholic University of America Press, 1947–.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("LB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Desiderii Erasmi Roterodami Opera Omnia")]), _vm._v(". 10 vols. Edited by Jean LeClerc. Leiden: Van der Aa, 1704–1706. Reprint, Hildesheim: Georg Olms, 1961–1962. Digital copy online at babel.hathitrust.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("LCC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Library of Christian Classics. 26 vols. Edited by John Baillie et al. Philadelphia: Westminster, 1953–1966.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("LCL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Loeb Classical Library. Edited by Jeffrey Henderson. Cambridge, MA: Harvard University Press, 1911–. Digital copy online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.loebclassics.com",
      "target": "_blank"
    }
  }, [_vm._v("www.loebclassics.com")]), _vm._v(".")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("LW")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Luther’s Works [American Edition]")]), _vm._v(". 82 vols. planned. St. Louis: Concordia; Philadelphia: Fortress, 1955–1986; 2009–.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("MO")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Philippi Melanthonis Opera quae supersunt omnia")]), _vm._v(". 28 vols. Corpus Reformatorum 1–28. Edited by C. G. Bretschneider. Halle: C. A. Schwetschke, 1834–1860. Digital copy online at archive.org and books.google.com")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NDB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Neue Deutsche Biographie")]), _vm._v(". 28 vols. projected. Berlin: Duncker & Humblot, 1953–.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NPNF")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church. 28 vols. in two series, denoted as NPNF and NPNF"), _c('sup', [_vm._v("2")]), _vm._v(". Edited by Philip Schaff et al. Buffalo, NY: Christian Literature, 1887–1894. Several reprints; also available online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.ccel.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ccel.org")]), _vm._v(".")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("OER")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Oxford Encyclopedia of the Reformation.")]), _vm._v(" 4 vols. Edited by Hans J. Hillerbrand. New York: Oxford University Press, 1996.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("PG")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Patrologia cursus completus. Series Graeca. 161 vols. Edited by J.-P. Migne. Paris: Migne, 1857–1866. Digital copies online at books.google.com.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("PL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Patrologia cursus completus. Series Latina. 221 vols. Edited by J.-P. Migne. Paris: Migne, 1844–1864. Digital copies online at books.google.com.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("QGT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Quellen zur Geschichte der Täufer. 18 vols. Leipzig: M. Heinsius; Gütersloh: Gerd Mohn, 1930–. The first two volumes are under the series title Quellen zur Geschichte der Wiedertäufer.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("RCS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Reformation Commentary on Scripture. 28 vols. projected. Edited by Timothy George and Scott M. Manetsch. Downers Grove, IL: IVP Academic, 2011–.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("r, v")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Some early books are numbered not by page but by folio (leaf). Front and back sides (pages) of a numbered folio are indicated by "), _c('i', [_vm._v("recto")]), _vm._v(" (r) and "), _c('i', [_vm._v("verso")]), _vm._v(" (v), respectively.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SCal")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Supplementa Calviniana: Sermon inédits.")]), _vm._v(" 11 vols. planned. Neukirchen-Vluyn: Neukirchener Verlag; Geneva: Droz, 1961–.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXVII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XVII"
    }
  }, [_vm._v("WA")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: [Schriften]")]), _vm._v(". 73 vols. Weimar: Hermann Böhlaus Nachfolger, 1883–2009. Digital copy online at archive.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("WABr")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: Briefwechsel")]), _vm._v(". 18 vols. Weimar: Hermann Böhlaus Nachfolger, 1930–1983. Digital copy online at archive.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("WADB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: Deutsche Bibel")]), _vm._v(". 12 vols. Weimar: Böhlaus Nachfolger, 1906–1961. Digital copy online at archive.org")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("WATR ")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: Tischreden")]), _vm._v(". 6 vols. Weimar: Hermann Böhlaus Nachfolger, 1912–1921. Digital copy online at archive.org.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ZSW")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Huldreich Zwinglis Sämtliche Werke")]), _vm._v(". 14 vols. Corpus Reformatorum 88–101. Edited by E. Egli et al. Berlin: C. A. Schwetschke, 1905–1959. Reprint, Zürich: Theologischer Verlag Zürich, 1983. Digital copy online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.irg.uzh.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.irg.uzh.ch")]), _vm._v(".")])])])])])])])]), _c('div', {
    staticClass: "sect",
    attrs: {
      "id": "sect-001"
    }
  }, [_c('h1', {
    staticClass: "sect_tit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXV"
    }
  }, [_c('span', [_vm._v("BIBLE TRANSLATIONS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BCP")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Book of Common Prayer (1979)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CEB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Common English Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("English Standard Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("King James Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Septuagint")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New American Standard Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New King James Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NRSV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Revised Standard Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Vg")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Vulgate")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0